// ABOUTME: Notification bell badge for the toolbar.
// ABOUTME: Polls unread count every 60 seconds and displays a red badge.

import { useState, useEffect, useCallback } from 'react';
import { Bell } from 'lucide-react';
import { notificationApi } from '@/services/api/client';
import { useAuth } from '@/context/AuthContext';

const POLL_INTERVAL_MS = 60_000; // 60 seconds

export function NotificationBadge() {
  const { isAuthenticated } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnreadCount = useCallback(async () => {
    if (!isAuthenticated) return;
    try {
      const { count } = await notificationApi.getUnreadCount();
      setUnreadCount(count);
    } catch (err) {
      console.error('[NotificationBadge] Failed to fetch unread count:', err);
    }
  }, [isAuthenticated]);

  // Poll on mount and every POLL_INTERVAL_MS
  useEffect(() => {
    if (!isAuthenticated) return;

    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [isAuthenticated, fetchUnreadCount]);

  return (
    <button
      className="relative w-9 h-9 rounded-sm flex items-center justify-center hover:bg-surface-100 transition-colors"
      aria-label={`Notifications${unreadCount > 0 ? ` (${unreadCount} unread)` : ''}`}
      title="Notifications"
      data-testid="notification-badge"
    >
      <Bell className="w-4 h-4 text-surface-500" />
      {unreadCount > 0 && (
        <span
          data-testid="notification-count"
          className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center"
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
}
